import { render, staticRenderFns } from "./tenant-data.vue?vue&type=template&id=60bd4f23&scoped=true&"
import script from "./tenant-data.ts?vue&type=script&lang=ts&"
export * from "./tenant-data.ts?vue&type=script&lang=ts&"
import style0 from "./tenant-data.scss?vue&type=style&index=0&id=60bd4f23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd4f23",
  null
  
)

export default component.exports